import { render } from "./client-registration-add.vue?vue&type=template&id=e8192b12&ts=true"
import script from "./client-registration-add.vue?vue&type=script&lang=ts"
export * from "./client-registration-add.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__